import {
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from '@mui/material';
import { Icon, Icons } from '@/common/components/Icon/Icon';
import {
  accordionActionsButtonStyles,
  accordionActionsButtonWrapperStyles,
  accordionActionsFooterStyles,
  accordionActionsStyles,
  accordionDetailsRichTextStyles,
  accordionDetailsStyles,
  accordionIconStyles,
  accordionStyles,
  accordionSummaryStyles,
} from './FaqItem.styles';

import CtaButtonCollection from '@/common/components/CtaButtonCollection/CtaButtonCollection';
import { FaqItem as FaqItemType } from '@/generated/contentfulTypes';
import Resource from '@/common/components/Resource/Resource';
import RichText from '@/common/components/RichText/RichText';

export default function FaqItem({
  titleField,
  body,
  footerTitleField,
  ctaButtonCollection,
}: FaqItemType) {
  const shouldRenderCtaButtons =
    ctaButtonCollection?.items && ctaButtonCollection.items.length > 0;

  return (
    <Accordion sx={accordionStyles}>
      <AccordionSummary
        sx={accordionSummaryStyles}
        expandIcon={
          <Icon
            icon={Icons.ChevronDown}
            sx={accordionIconStyles}
            color="white"
          />
        }
        aria-controls={`panel-${titleField}-content`}
        id={`panel-${titleField}-header`}
      >
        {titleField && (
          <Typography component="h3" variant="h10">
            <Resource value={titleField} />
          </Typography>
        )}
      </AccordionSummary>
      <AccordionDetails sx={accordionDetailsStyles}>
        <Typography component="div" variant="body1">
          <RichText
            content={body?.json.content}
            sx={accordionDetailsRichTextStyles}
          />
        </Typography>
      </AccordionDetails>

      {shouldRenderCtaButtons && (
        <AccordionActions sx={accordionActionsStyles}>
          <Box sx={accordionActionsFooterStyles}>
            {footerTitleField && (
              <Typography component="p">{footerTitleField}</Typography>
            )}
            <CtaButtonCollection
              sx={accordionActionsButtonWrapperStyles}
              buttonSx={accordionActionsButtonStyles}
              buttons={ctaButtonCollection?.items}
            />
          </Box>
        </AccordionActions>
      )}
    </Accordion>
  );
}
